import { Checkbox, TextInput } from '@mantine/core';
import { DateInput } from 'components/inputs/DateInput';
import { IFormInputSpecConstant } from 'pages/revisions-module/template-editor/editors/form/types';

interface ConstantInputPreviewProps {
  spec: IFormInputSpecConstant;
}

/**
 * Preview for a constant input.
 */
export default function ConstantInputPreview({ spec }: ConstantInputPreviewProps) {
  if (spec.constantType === 'bool') {
    return <Checkbox size="sm" readOnly disabled checked={!!spec.value} onChange={() => undefined} />;
  }

  if (spec.constantType === 'date') {
    return <DateInput size="sm" readOnly value={typeof spec.value === 'string' ? spec.value : ''} />;
  }

  return <TextInput size="sm" readOnly value={String(spec.value ?? '')} placeholder="Konštantná hodnota" />;
}
